import { setComponentMapOverrides } from '@jutro/uiconfig';

import FNOLCAWizard from './FNOLCAWizard';
import FNOLCAWhatPage from './pages/What/WhatPage';
import FNOLCAVehiclesPage from './pages/Vehicles/VehiclesPage';
/*import FNOLCACollisionDetailsPage from './pages/Details/Collision/CollisionDetailsPage';
import FNOLCAGlassDetailsPage from './pages/Details/Glass/GlassDetailsPage';
import FNOLCATheftDetailsPage from './pages/Details/Theft/TheftDetailsPage';*/
import FNOLCAVehiclePassengersPage from "./pages/Vehicles/VehiclePassengers";
import FNOLCAFleetPage from './pages/Fleet/FleetPage';
import FNOLCALossDetailsPage from './pages/Details/LossDetails/LossDetailsPage';

setComponentMapOverrides(
    {
        FNOLCAWizard: { component: 'FNOLCAWizard' },
        FNOLCAWhatPage: { component: 'FNOLCAWhatPage' },
        FNOLCAVehiclesPage: { component: 'FNOLCAVehiclesPage' },
        /*FNOLCACollisionDetailsPage: { component: 'FNOLCACollisionDetailsPage' },
        FNOLCAGlassDetailsPage: { component: 'FNOLCAGlassDetailsPage' },
        FNOLCATheftDetailsPage: { component: 'FNOLCATheftDetailsPage' },*/
        FNOLCAFleetPage: { component: 'FNOLCAFleetPage' },
        FNOLCALossDetailsPage: {component: 'FNOLCALossDetailsPage'},
        FNOLCAVehiclePassengersPage: {component: 'FNOLCAVehiclePassengersPage'}
    },
    {
        FNOLCAWizard,
        FNOLCAWhatPage,
        FNOLCAVehiclesPage,
        /*FNOLCACollisionDetailsPage,
        FNOLCAGlassDetailsPage,
        FNOLCATheftDetailsPage,*/
        FNOLCAFleetPage,
        FNOLCALossDetailsPage,
        FNOLCAVehiclePassengersPage
    }
);

export {
    FNOLCAWizard as default
};
